import axios from 'axios';
import constants from '../constants';


function spellCheck(menuId, memberId, internal = false) {
  return axios.post(`${constants.urlPrefix}/api/ai/menu/${menuId}/spellCheck`, {
    agent: internal ? "mhm" : "external",
    memberId,
  });
}

function printCheck(menuId, memberId,  internal = false) {
  return axios.post(`${constants.urlPrefix}/api/ai/menu/${menuId}/printCheck`, {
    agent: internal ? "mhm" : "external",
    memberId,
  });
}

function designTips(menuId, memberId, internal = false) {
  return axios.post(`${constants.urlPrefix}/api/ai/menu/${menuId}/designTips`, {
    agent: internal ? "mhm" : "external",
    memberId,
  });
}

function onboardMenu(formData) {
  return axios.post(`${constants.urlPrefix}/api/ai/menu/onboard`, formData);
}

function postFeedback(feedback) {
  return axios.post(`${constants.urlPrefix}/api/ai/feedback`, feedback);
}

export default {
  onboardMenu,
  spellCheck,
  printCheck,
  designTips,
  postFeedback
};
